import { TranslationService } from '../services/translation.service'
import { SustainabilityHighlight } from '../types/sustainabilityHighlight'

const translationService = new TranslationService()

export const FULL_INGREDIENT_DISCLOSURE: SustainabilityHighlight = {
  imageSrc: 'assets/sustainability_highlights/full_ingredient_disclosure.svg',
  alt: translationService.getFullIngredientDisclosureText(),
  description: translationService.getFullIngredientDisclosureDescriptionText(),
}

export const PARTIAL_INGREDIENT_DISCLOSURE: SustainabilityHighlight = {
  imageSrc:
    'assets/sustainability_highlights/partial_ingredient_disclosure.svg',
  alt: translationService.getPartialIngredientDisclosureText(),
  description:
    translationService.getPartialIngredientDisclosureDescriptionText(),
}
